/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import { COMMON_ERROR, CLEAR_ERROR } from './ApplicationDetailsErrorTypes';

export const setError = (message, errorType) => ({
    type: COMMON_ERROR,
    payload: {
        message,
        errorType
    }
});

export const clearError = () => ({
    type: CLEAR_ERROR
});